import React, { Component } from 'react';
import EventBus from '../service/eventbus';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { getStudent, getSchool, setYear } from '../service/service';
import { FaRegUser } from 'react-icons/fa';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: false,
            student: null,
            school: null,
        };
    }

    async componentDidMount() {
        //console.log("navbar mount");
        if (window.location && window.location.search) {
            var token = new URLSearchParams(window.location.search).get("t");
            if (token != null)
                localStorage.setItem("_t", token);
        }

        var student = await getStudent();
        this.setState({ student: student });

        var school = await getSchool();
        this.setState({ school: school });
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    
    formatClassName(clsId) {
        if (typeof clsId !== 'number' || clsId < 100 || clsId > 1500) return clsId;

        const hebrewLayers = [
            '', 'א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'יא', 'יב', 'יג', 'יד'
        ];
        const layerNum = Math.floor(clsId / 100);
        const classNum = clsId % 100;

        const layerName = hebrewLayers[layerNum] || layerNum.toString();
        return layerName + "-" + classNum;
    }
    

    render() {
        return (
            <header>
                <Navbar className="navbar-expand" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/">
                            {this.state.school &&
                                <img src={this.state.school.logo} height="77" alt="logo" />
                            }
                        </NavbarBrand>
                        <Collapse className="d-sm-inline-flex flex-sm-row" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark font-weight-bold" to="/">בית</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark font-weight-bold" to="/enroll">הרשמה</NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
                        <div>
                            <ul className="navbar-nav far">
                                {this.state.student &&
                                    <NavItem>
                                        <select
                                            className="shf-year-select"
                                            style={{ marginLeft: '50px', minWidth: '75px', height: '38px' }}
                                            onChange={e => {
                                                console.log('Selected year:', e.target.value);
                                                setYear(e.target.value)
                                                    .then(() => {
                                                        EventBus.emit('studyYearChanged');

                                                        getStudent().then((student) => {
                                                            this.setState({ student: student });
                                                        });
                                                        getSchool().then((school) => {
                                                            this.setState({ school: school });
                                                        });

                                                        

                                                        //window.location.reload();
                                                        //this.setState()
                                                    })
                                                    .catch(err => {
                                                        console.error('Error setting year:', err);
                                                    });
                                            }}
                                            value={this.state.school ? this.state.school.studyYear : '' }
                                        >
                                            <option value="">שנ"ל</option>
                                            <option value="2026">תשפ"ו</option>
                                            <option value="2027">תשפ"ז</option>
                                        </select>
                                    </NavItem>
                                }
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="">
                                        {this.state.student && this.state.student.name}
                                        {this.state.student ? ' (' + this.formatClassName(this.state.student.classId) + ')' : ''}
                                        {this.state.student &&
                                            <FaRegUser size="25px" style={{ color: '#777777', marginRight: '5px' }} />}
                                    </NavLink>
                                </NavItem>
                            </ul>
                        </div>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
